module.exports = __webpack_public_path__ + "img/default-loading.01ebcb68.jpg";